import React from 'react';
import SalarySmsSheet from './SalarySmsSheet';

export default function SalarySlipPage() {
  return <SalarySmsSheet documentLabel="Salary Slip" />;
}
